import { render, staticRenderFns } from "./therapyCategory.vue?vue&type=template&id=0bb3c8d3&"
import script from "./therapyCategory.vue?vue&type=script&lang=js&"
export * from "./therapyCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports